import { SortingState } from "@tanstack/react-table";
import { ScreeningStatus } from "shared/types";
import type { ApplicationFilters } from "../hooks/useApplicationQueryParams";

const isReverifyingOnlyFilter = (filters?: ApplicationFilters) =>
  filters?.screeningStatuses?.length === 1 &&
  filters.screeningStatuses[0] === ScreeningStatus.Reverifying;

export const getApplicationSorts = (
  sorting: SortingState,
  filters?: ApplicationFilters
) => {
  if (sorting[0])
    return [{ [sorting[0].id]: sorting[0].desc ? "desc" : "asc" }];
  if (isReverifyingOnlyFilter(filters))
    return [{ reverification_requested_at: "asc" }];
  return [];
};
